import React, { forwardRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { MDBBtn, MDBModalFooter, MDBSpinner } from "mdb-react-ui-kit";
import { useNavigate } from "react-router";
import { setGlobalLocationFilter } from "../../../apiclients/streamsapi_bridge";

const DeleteLocationFilter = forwardRef((props, ref) => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [isloading, setIsloading] = useState(false)

    async function removeThisFilter(e) {
        e.preventDefault();
        const siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
        console.log(JSON.parse(sessionStorage.getItem("admin_session")).siteid);
        setIsloading(true);
        let update = {
            reqid: 62,
            siteid: siteid,
            filter_value: [-1],
            filter_type: 1,
            filter_key: 3,
        }

        console.log("Modify User filter value  :::: " + JSON.stringify(update));
        let deleteFilter = await setGlobalLocationFilter(update);
        setIsloading(false);
        let deleteMsg = await deleteFilter.json();
        console.log("Response... ");
        console.log(deleteMsg);
        if (deleteMsg.status == "Failed") {
            localStorage.setItem(
                "user_create_f",
                "Something went wrong, Please try again after sometime"
            );
            props.onClose();
            if (props.locationflag && props.locationflag === 1) {
                navigate("/userlanding", {
                    state: { tab: "suser", tab2: "sloc" },

                });
                window.location.reload();
            } else {
                window.location.href = "/LocLanding";
            }

        } else {
            localStorage.setItem("s_message", deleteMsg.message);
            sessionStorage.removeItem('userLocationFilter');
            props.onClose();
            navigate("/userlanding", {
                state: { tab: "suser", tab2: "sloc" },
            });
            window.location.reload();

        }
    }

    return (
        <>
            {isloading && (
                <>
                    <div className="loadingclass">
                        <MDBBtn disabled>
                            <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                            Loading...
                        </MDBBtn>
                    </div>
                </>
            )}
            <div>
                <span className="phrecording">{t("RemoveLocationFiltertxt")}</span>
            </div>
            {/* <MDBModalFooter>
                <MDBBtn color="secondary" onClick={props.onClose}>
                    {t("cancel")}
                </MDBBtn>
                <MDBBtn onClick={(e) => removeThisFilter(e)}>{t("remove")}</MDBBtn>
            </MDBModalFooter> */}
             <div style={{ display: "none" }}>
						<button ref={ref} onClick={(e) =>  removeThisFilter(e)}>
							{t("add")}</button>
					</div>
        </>
    )
});

export default DeleteLocationFilter
